import React, { useState } from 'react';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // CV file path
  const cvFilePath = "/CV/cv.pdf";

  const projectsData = [
    {
      id: 1,
      title: "3 BR Bungalow Design",
      location: "Juja, Kiambu",
      description: "A contemporary 3-bedroom bungalow featuring sustainable design elements, solar integration, and smart home technology. Includes detailed construction documentation and 3D visualizations.",
      features: ["Solar Power Integration", "Rainwater Harvesting", "Smart Home Systems", "Landscaped Gardens"],
      images: [
        "/images/projects/kiambu/3%20Br%20Bungalow%202%20Juja%20Kiambu.jpg"
      ],
      year: 2025,
      area: "131 sqm",
      client: "Private Client",
      services: ["Design", "3D Visualization", "Documentation"]
    },
    {
      id: 2,
      title: "3 BR Flat-Roofed Bungalow Design",
      location: "Nyeri",
      description: "A modern three-bedroom bungalow featuring a clean flat-roof design, open-plan living spaces, and ample natural lighting. Designed for efficient space use, comfort, and a contemporary aesthetic suited for Nyeri's environment.",
      features: ["3 bedrooms (master ensuite)", "Open-plan living & dining", "Flat-roof style with sleek façade", "Parking provision"],
      images: [
        "/images/projects/nyeri/Flatroof%20bungalow%20in%20nyeri.jpg",
        "/images/projects/nyeri/Nyeri%20Flatroof.jpg"
      ],
      year: 2025,
      area: "81 sqm",
      client: "Private Client",
      services: ["Design", "Documentation", "Supervision"]
    },
    {
      id: 3,
      title: "Residential Studio Apartment Design",
      location: "Kiambu",
      description: "A compact, modern studio apartment designed for efficient living in an urban Kiambu setting. The layout maximizes limited space through open-plan organization, smart storage, and a clean contemporary façade.",
      features: ["Open-plan living/sleeping area", "Efficient bathroom layout", "Sleek contemporary exterior", "Compact kitchen & bathroom"],
      images: [
        "/images/projects/weitethia/studioapartment.jpg",
        "/images/projects/weitethia/studioappartment.jpg"
      ],
      year: 2025,
      area: "150 sqm",
      client: "Private Client",
      services: ["Design", "Documentation", "Supervision"]
    },
    {
      id: 4,
      title: "5 BR Maisonnate Design",
      location: "Kibra, Nairobi",
      description: "A spacious two-level family home designed for urban living in Kibra. The maisonette features generous room sizes, modern finishes, and functional zoning to balance privacy and shared spaces.",
      features: ["5 bedrooms (master ensuite)", "Parking provision", "Modern kitchen with pantry", "Large windows for natural lighting"],
      images: [
        "/images/projects/nairobi/kibra.jpg"
      ],
      year: 2025,
      area: "130 sqm",
      client: "Private Client",
      services: ["Design", "Documentation", "Supervision"]
    },
    {
      id: 5,
      title: "4 BR Mansionate Design",
      location: "Joska, Machakos",
      description: "A luxurious four-bedroom mansionette designed for comfort and elegance in Joska. The design incorporates spacious living areas, high-end finishes, and outdoor spaces to create a refined living experience.",
      features: ["4 bedrooms (master ensuite)", "Modern kitchen + pantry", "Playground", "Security Systems"],
      images: [
        "/images/projects/thika/4%20br%20mansionate%202%20joska.jpg",
        "/images/projects/thika/4Br%20massionate%20in%20joska%20Machakos.jpg"
      ],
      year: 2025,
      area: "100 sqm",
      client: "Private Client",
      services: ["Design", "Documentation"]
    }
  ];

  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "Projects", href: "#projects" },
    { name: "Skills", href: "#skills" },
    { name: "Contact", href: "#contact" }
  ];

  const openProjectDetails = (project) => {
    setSelectedProject(project);
  };

  const closeProjectDetails = () => {
    setSelectedProject(null);
  };

  const handleDownloadCV = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = cvFilePath;
    link.download = 'Bonface_Omollo_CV.pdf'; // Name of downloaded file
    link.target = '_blank'; // Open in new tab for better UX
    
    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className={`app ${darkMode ? 'dark-mode' : ''}`}>
      {/* Enhanced Navbar */}
      <nav className="navbar">
        <div className="container nav-content">
          <div className="nav-left">
            <a 
              href="#home" 
              className="logo"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('#home');
              }}
            >
              <span className="logo-first">BONIFACE</span>
              <span className="logo-last">OMOLLO</span>
            </a>
          </div>

          <div className={`nav-center ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
              >
                {link.name}
              </a>
            ))}
          </div>

          <div className="nav-right">
            <div className="nav-actions">
              <button 
                className="btn nav-btn secondary"
                onClick={handleDownloadCV}
              >
                📄 Download CV
              </button>
              <button 
                className="theme-toggle"
                onClick={() => setDarkMode(!darkMode)}
                aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              >
                {darkMode ? '☀️ Light' : '🌙 Dark'}
              </button>
              <button 
                className="mobile-menu-toggle"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle mobile menu"
              >
                {mobileMenuOpen ? '✕' : '☰'}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="mobile-nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
              >
                {link.name}
              </a>
            ))}
            <button 
              className="btn mobile-cv-btn"
              onClick={handleDownloadCV}
            >
              📄 Download CV
            </button>
          </div>
        </div>
      )}

      <main>
        {/* Hero Section */}
        <section id="home" className="hero">
          <div className="container">
            <div className="hero-content">
              <div className="hero-text">
                <h1 className="hero-title">
                  <span className="hero-first">BONIFACE</span>
                  <span className="hero-last"> OMOLLO</span>
                </h1>
                <p className="title">Architectural Technician & Designer</p>
                <p className="hero-description">
                  With over 1 year of experience in architectural design and technical documentation, 
                  I specialize in transforming concepts into buildable realities. Passionate about 
                  sustainable design and innovative solutions that enhance user experience.
                </p>
                <div className="hero-buttons">
                  <a 
                    href="#projects" 
                    className="btn"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('#projects');
                    }}
                  >
                    View Projects
                  </a>
                  <button className="btn secondary" onClick={handleDownloadCV}>
                    📄 Download CV
                  </button>
                </div>
                <div className="hero-stats">
                  <div className="stat">
                    <span className="stat-number">{projectsData.length}+</span>
                    <span className="stat-label">Projects</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">100%</span>
                    <span className="stat-label">Client Satisfaction</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">3</span>
                    <span className="stat-label">Design Tools</span>
                  </div>
                </div>
              </div>
              <div className="hero-image">
                <div className="profile-image-container">
                  <img 
                    src="/images/profile/Boniface%20profile.jpg" 
                    alt="Boniface Omollo - Architectural Technician"
                    className="profile-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/400x500/cccccc/666666?text=Bonface+Omollo";
                    }}
                  />
                  <div className="profile-badge">
                    <span>Architectural Technician/Designer</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="projects" className="projects">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Architectural Projects</h2>
              <p className="section-subtitle">A showcase of my recent architectural designs and technical documentation work</p>
            </div>
            <div className="projects-grid">
              {projectsData.map((project) => (
                <div key={project.id} className="project-card">
                  <div className="project-image-container">
                    <div 
                      className="project-main-image"
                      style={{
                        backgroundImage: `url(${project.images[0]})`,
                      }}
                    >
                      <div className="image-count">
                        <span className="count-number">{project.images.length}</span>
                        <span className="count-text">images</span>
                      </div>
                    </div>
                  </div>
                  <div className="project-info">
                    <div className="project-header">
                      <h3 className="project-title">{project.title}</h3>
                      <p className="project-location">📍 {project.location}</p>
                    </div>
                    <p className="project-description">{project.description.substring(0, 120)}...</p>
                    <div className="project-meta">
                      <div className="meta-item">
                        <span className="meta-label">Year:</span>
                        <span className="meta-value">{project.year}</span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Area:</span>
                        <span className="meta-value">{project.area}</span>
                      </div>
                    </div>
                    <button 
                      className="btn project-btn"
                      onClick={() => openProjectDetails(project)}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Project Details Modal */}
        {selectedProject && (
          <div className="modal-overlay" onClick={closeProjectDetails}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeProjectDetails} aria-label="Close">×</button>
              <div className="modal-header">
                <h2 className="modal-title">{selectedProject.title}</h2>
                <p className="modal-subtitle">
                  <span className="modal-location">📍 {selectedProject.location}</span>
                  <span className="modal-year"> • {selectedProject.year}</span>
                </p>
              </div>
              
              <div className="modal-gallery">
                {selectedProject.images.map((image, index) => (
                  <div key={index} className="modal-image-item">
                    <div 
                      className="modal-image"
                      style={{
                        backgroundImage: `url(${image})`,
                      }}
                    />
                    <p className="image-caption">
                      Image {index + 1} of {selectedProject.images.length}
                    </p>
                  </div>
                ))}
              </div>
              
              <div className="modal-body">
                <div className="modal-main">
                  <div className="modal-section">
                    <h3 className="section-title">Project Description</h3>
                    <p className="description-text">{selectedProject.description}</p>
                  </div>
                  
                  <div className="modal-section">
                    <h3 className="section-title">Key Features</h3>
                    <div className="features-grid">
                      {selectedProject.features.map((feature, index) => (
                        <span key={index} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="modal-section">
                    <h3 className="section-title">Services Provided</h3>
                    <div className="services-grid">
                      {selectedProject.services.map((service, index) => (
                        <span key={index} className="service-tag">
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="modal-sidebar">
                  <div className="sidebar-card">
                    <h3 className="sidebar-title">Project Specifications</h3>
                    <div className="specs-list">
                      <div className="spec-item">
                        <span className="spec-label">Client:</span>
                        <span className="spec-value">{selectedProject.client}</span>
                      </div>
                      <div className="spec-item">
                        <span className="spec-label">Location:</span>
                        <span className="spec-value">{selectedProject.location}</span>
                      </div>
                      <div className="spec-item">
                        <span className="spec-label">Area:</span>
                        <span className="spec-value">{selectedProject.area}</span>
                      </div>
                      <div className="spec-item">
                        <span className="spec-label">Year:</span>
                        <span className="spec-value">{selectedProject.year}</span>
                      </div>
                      <div className="spec-item">
                        <span className="spec-label">Images:</span>
                        <span className="spec-value">{selectedProject.images.length}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Skills Section */}
        <section id="skills" className="skills">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Skills & Expertise</h2>
              <p className="section-subtitle">Technical proficiency in architectural design and documentation tools</p>
            </div>
            <div className="skills-container">
              <div className="skill-category">
                <h3 className="category-title">
                  <span className="category-icon">✏️</span>
                  Design & Visualization
                </h3>
                <ul className="skills-list">
                  <li className="skill-item">
                    <span className="skill-name">ArchiCAD</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '95%' }}></div>
                    </div>
                    <span className="skill-percentage">95%</span>
                  </li>
                  <li className="skill-item">
                    <span className="skill-name">Lumion</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '90%' }}></div>
                    </div>
                    <span className="skill-percentage">90%</span>
                  </li>
                  <li className="skill-item">
                    <span className="skill-name">Artlantis</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '85%' }}></div>
                    </div>
                    <span className="skill-percentage">85%</span>
                  </li>
                </ul>
              </div>
              <div className="skill-category">
                <h3 className="category-title">
                  <span className="category-icon">📐</span>
                  Technical Documentation
                </h3>
                <ul className="skills-list">
                  <li className="skill-item">
                    <span className="skill-name">Construction Drawings</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '96%' }}></div>
                    </div>
                    <span className="skill-percentage">96%</span>
                  </li>
                  <li className="skill-item">
                    <span className="skill-name">Working Drawings</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '94%' }}></div>
                    </div>
                    <span className="skill-percentage">94%</span>
                  </li>
                  <li className="skill-item">
                    <span className="skill-name">Detail Drawings</span>
                    <div className="skill-bar">
                      <div className="skill-level" style={{ width: '92%' }}></div>
                    </div>
                    <span className="skill-percentage">92%</span>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* CV Download Section */}
            <div className="cv-section">
              <div className="cv-card">
                <div className="cv-content">
                  <h3 className="cv-title">📄 Professional CV Available</h3>
                  <p className="cv-description">
                    Download my detailed curriculum vitae to learn more about my qualifications, 
                    experience, and professional background in architectural design.
                  </p>
                  <div className="cv-info">
                    <div className="cv-info-item">
                      <span className="cv-info-label">Format:</span>
                      <span className="cv-info-value">PDF</span>
                    </div>
                    <div className="cv-info-item">
                      <span className="cv-info-label">Size:</span>
                      <span className="cv-info-value">Approx. 1-2 MB</span>
                    </div>
                  </div>
                  <button 
                    className="btn cv-download-btn"
                    onClick={handleDownloadCV}
                  >
                    📥 Download My CV
                  </button>
                  <p className="cv-note">
                    The CV includes detailed information about my education, work experience, 
                    technical skills, and project portfolio.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="contact">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Get In Touch</h2>
              <p className="section-subtitle">Have a project in mind? Or an opportunity? Let's discuss!</p>
            </div>
            <div className="contact-container">
              <div className="contact-info">
                <div className="info-card">
                  <h3 className="info-title">Contact Information</h3>
                  <p className="info-text">
                    I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision.
                  </p>
                  <div className="contact-details">
                    <div className="contact-item">
                      <div className="contact-icon">📧</div>
                      <div className="contact-text">
                        <h4 className="contact-type">Email</h4>
                        <a href="mailto:onyangobonface554@gmail.com" className="contact-value">
                          onyangobonface554@gmail.com
                        </a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="contact-icon">📞</div>
                      <div className="contact-text">
                        <h4 className="contact-type">Phone</h4>
                        <a href="tel:+254794815701" className="contact-value">
                          +254 794 815 701
                        </a>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="contact-icon">📍</div>
                      <div className="contact-text">
                        <h4 className="contact-type">Location</h4>
                        <p className="contact-value">Nairobi, Kenya</p>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="contact-icon">📄</div>
                      <div className="contact-text">
                        <h4 className="contact-type">CV</h4>
                        <button 
                          className="contact-value cv-link"
                          onClick={handleDownloadCV}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: 'inherit',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            padding: 0,
                            font: 'inherit'
                          }}
                        >
                          Download CV (PDF)
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-form-container">
                <form className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input 
                      type="text" 
                      id="name"
                      className="form-input"
                      placeholder="Your name" 
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input 
                      type="email" 
                      id="email"
                      className="form-input"
                      placeholder="your.email@example.com" 
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message" className="form-label">Message</label>
                    <textarea 
                      id="message"
                      className="form-textarea"
                      placeholder="Tell me about your project..." 
                      rows="5"
                      required
                    ></textarea>
                  </div>
                  <button type="submit" className="btn form-submit">Send Message</button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <h3 className="footer-logo">BONIFACE OMOLLO</h3>
              <p className="footer-tagline">Architectural Technician & Designer</p>
              <p className="footer-description">
                Transforming architectural concepts into buildable realities with precision and creativity.
              </p>
              <button 
                className="btn footer-cv-btn"
                onClick={handleDownloadCV}
              >
                📄 Download CV
              </button>
            </div>
            <div className="footer-links">
              <h4 className="links-title">Quick Links</h4>
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="footer-link"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(link.href);
                  }}
                >
                  {link.name}
                </a>
              ))}
            </div>
            <div className="footer-contact">
              <h4 className="contact-title">Contact</h4>
              <a href="mailto:onyangobonface554@gmail.com" className="footer-contact-link">
                📧 onyangobonface554@gmail.com
              </a>
              <a href="tel:+254794815701" className="footer-contact-link">
                📞 +254 794 815 701
              </a>
              <button 
                className="footer-contact-link cv-footer-link"
                onClick={handleDownloadCV}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'inherit',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  width: '100%'
                }}
              >
                📄 Download CV
              </button>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} Boniface Omollo. All rights reserved.</p>
            <p className="footer-note">
              Designed & Developed with passion for architectural excellence
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;